var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.$can('no-access', 'not-allowed'))?_c('b-card',{attrs:{"title":"Client related Stuff 🔒"}},[_c('b-card-text',[_vm._v("Client related stuff.")])],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }